import * as React from 'react';
import { FelaComponent, Container } from '@filou/core';
import ScrollListener from './scroll-listener';
import Spacer from './spacer';
import Link from './anchor-link';
var NavBarNav = function (_a) {
    var children = _a.children;
    return (React.createElement(FelaComponent, { style: {
            display: 'flex',
            ifSmallDown: {
                display: 'none'
            }
        }, render: function (_a) {
            var className = _a.className;
            return React.createElement("div", { className: className }, children);
        } }));
};
var NavBar = function (_a) {
    var Logo = _a.logo, _b = _a.nav, nav = _b === void 0 ? [] : _b;
    return (React.createElement(ScrollListener, { render: function (top, activeId) { return (React.createElement(React.Fragment, null,
            React.createElement(FelaComponent, { style: {
                    height: 20
                } }),
            React.createElement(FelaComponent, { rule: function (_a) {
                    var theme = _a.theme;
                    return ({
                        height: 50,
                        backgroundColor: 'white',
                        position: 'sticky',
                        zIndex: 1,
                        top: 0,
                        left: 0,
                        width: '100%',
                        marginY: 20,
                        boxShadow: top > 50 + 28 ? theme.boxShadow : undefined
                    });
                } },
                React.createElement(FelaComponent, { style: {
                        display: 'flex',
                        alignItems: 'center'
                    }, render: function (_a) {
                        var className = _a.className;
                        return (React.createElement(Container, { className: className },
                            React.createElement(Logo, { key: "logo", scale: top > 50 ? 0.8 : 1 }),
                            React.createElement(Spacer, null),
                            React.createElement(NavBarNav, null, nav.map(function (x) { return (React.createElement(Link, { key: x, to: "#" + x.toLowerCase(), active: activeId === x.toLowerCase() }, x)); }))));
                    } })),
            React.createElement(FelaComponent, { style: {
                    height: 20
                } }))); } }));
};
export default NavBar;
//# sourceMappingURL=index.js.map